import { render, staticRenderFns } from "./block-document-statuses.vue?vue&type=template&id=18c75b75&scoped=true&lang=pug"
import script from "./block-document-statuses.vue?vue&type=script&lang=js"
export * from "./block-document-statuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c75b75",
  null
  
)

export default component.exports